import React, { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import "./invoice.css";
import { useParams } from "react-router-dom";

function ParentTransactionInvoice({ parentTransactionId }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
 const { id } = useParams();
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const val = (v) =>
    v !== null && v !== undefined && v !== "" ? v : "-";

  useEffect(() => {
    fetchInvoice();
  }, []);

  const fetchInvoice = async () => {
    setLoading(true);
     const customer_id = localStorage.getItem("customer_id");
      const api_key = localStorage.getItem("api_key");
    try {
      const payload = {
        customer_id: customer_id  ,
        api_key: api_key,
        language: "en",
        parent_transactions_id: Number(id),
        action: "success",
      };

      const res = await simplePostCall(
        ApiConfig.parentfailedtransactionView,
        JSON.stringify(payload)
      );

      if (res?.result && res?.data) {
        setData(res.data);
      }
    } catch (err) {
      console.error("Invoice fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!data) {
    return <div className="text-center">No invoice data found</div>;
  }

  const student = data.studentModel?.[0] || {};
  const transaction = data.parent_transaction_model?.[0] || {};
  const invoice = data.parent_invoice?.[0] || {};
  const layout = data.invoice_layout?.[0] || {};

  return (
    <div className="container-fluid py-4">
      {/* HEADER */}
      <div className="bg-white p-3 rounded shadow-sm mb-3 d-flex justify-content-between">
        <h5 className="fw-bold  mb-0">View Invoices</h5>
        <div className="d-flex gap-2">
          <Button size="sm" variant="secondary">Print</Button>
          <Button size="sm" variant="danger">Remove Receipt</Button>
        </div>
      </div>

      {/* RECEIPT */}
      <div className="bg-white p-4 rounded shadow-sm">

        {/* CUSTOM HEADER FROM API */}
        {layout.receipt_layout_header && (
          <div
            className="text-center mb-3"
            dangerouslySetInnerHTML={{
              __html: layout.receipt_layout_header,
            }}
          />
        )}

        <div className="text-center mb-4">
          <div className="fw-bold">
            Sharjah - United Arab Emirates, {val(student.student_mobile)}
          </div>
          <div>{val(student.student_email)}</div>
          <h4 className="mt-3">Receipt</h4>
        </div>

        {/* STUDENT + TRANSACTION INFO */}
        <div className="border p-3 mb-4">
          <div className="row mb-2">
            <div className="col-md-4">
              <b>Admission No:</b> {val(student.student_admission_num)}
            </div>
            <div className="col-md-4">
              <b>Academic Year:</b> -
            </div>
            <div className="col-md-4">
              <b>Invoice Date:</b>{" "}
              {transaction.transaction_initialized_datetime
                ? new Date(
                    transaction.transaction_initialized_datetime
                  ).toLocaleDateString()
                : "-"}
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4">
              <b>Name:</b> {val(student.student_name)}
            </div>
            <div className="col-md-4">
              <b>Receipt No:</b>{" "}
              {val(invoice.parent_transaction_invoices_id)}
            </div>
            <div className="col-md-4">
              <b>Invoice No:</b>{" "}
              {val(invoice.parent_transaction_invoices_invoice_id)}
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-4">
              <b>Grade:</b>{" "}
              {val(student.class_name)} ({val(student.class_division_name)})
            </div>
            <div className="col-md-4">
              <b>Transaction ID:</b>{" "}
              {val(transaction.transaction_merchant_reference)}
            </div>
            <div className="col-md-4">
              <b>Paid Date:</b>{" "}
              {transaction.transaction_updated_datetime
                ? new Date(
                    transaction.transaction_updated_datetime
                  ).toLocaleString()
                : "-"}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <b>Mode of Transaction:</b>{" "}
              {val(transaction.transaction_mode)}
            </div>
          </div>
        </div>

        {/* INVOICE TABLE (amounts not provided yet) */}
        {/* <div className="invoice-table-wrapper">
          <table className="invoice-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Particulars</th>
                <th>Terms/Semester</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{val(invoice.parent_transaction_invoices_invoice_of)}</td>
                <td>-</td>
                <td className="summary-amount">
                  {val(invoice.parent_transaction_invoices_transaction_amount)}
                </td>
              </tr>

              <tr>
                <td></td><td></td>
                <td className="summary-label">Payment Received</td>
                <td className="summary-amount">
                  {val(transaction.transaction_amount)}
                </td>
              </tr>

              <tr>
                <td></td><td></td>
                <td className="summary-label">Balance</td>
                <td className="summary-amount">-</td>
              </tr>
            </tbody>
          </table>
        </div> */}

        <div className="invoice-table-wrapper">
  <table className="invoice-table">
    <thead>
      <tr>
        <th>#</th>
        <th>Particulars</th>
        <th>Terms/Semester</th>
        <th>Amount</th>
      </tr>
    </thead>

    <tbody>
      {/* MAIN LINE ITEM */}
      <tr>
        <td>1</td>
        <td>
          <div className="particular-main">
            {val(invoice?.parent_transaction_invoices_invoice_of)}
          </div>
          <div className="particular-sub">Arrear Discount</div>
          <div className="particular-sub">Additional Charges</div>
        </td>
        <td>-</td>
        <td className="amount-cell">
          <div>
            {val(
              invoice?.parent_transaction_invoices_transaction_amount
            )}
          </div>
          <div>-</div>
          <div>-</div>
        </td>
      </tr>

      {/* SUMMARY BLOCK */}
      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Sub Total</td>
        <td className="summary-amount">-</td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Discount</td>
        <td className="summary-amount">-</td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Tax/Additional Charges</td>
        <td className="summary-amount">-</td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td className="summary-label summary-bold">
          Grand Total
        </td>
        <td className="summary-amount summary-bold">-</td>
      </tr>

      {/* PAYMENT SECTION */}
      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Payment received</td>
        <td className="summary-amount">
          {val(transaction?.transaction_amount)}
        </td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Total Amount Paid</td>
        <td className="summary-amount">
          {val(transaction?.transaction_amount)}
        </td>
      </tr>

      <tr>
        <td></td>
        <td></td>
        <td className="summary-label">Balance</td>
        <td className="summary-amount">-</td>
      </tr>
    </tbody>
  </table>
</div>


        {/* FOOTER FROM API */}
        {/* {layout.receipt_layout_footer && (
          <div
            className="mt-4"
            dangerouslySetInnerHTML={{
              __html: layout.receipt_layout_footer,
            }}
          />
        )} */}

        {/* BELOW TABLE FOOTER TEXT */}
<div className="invoice-footer-text mt-4">

  <p>
    <strong>Payment received :</strong>{" "}
    {transaction?.transaction_amount
      ? `${transaction.transaction_amount} ${customer_currency} Only.`
      : "-"}
  </p>

  <p>
    <strong>Total Due :</strong>{" "}
    -
  </p>

    {layout.receipt_layout_footer && (
          <div
            className="mt-4"
            dangerouslySetInnerHTML={{
              __html: layout.receipt_layout_footer,
            }}
          />
        )}

</div>
      </div>
    </div>
  );
}

export default ParentTransactionInvoice;
